"use strict";

export default {
  // Global
  overlay: "[data-overlay]",
  modal: "[data-modal]",
  modalBtn: "[data-modal-btn]",
  closeModalBtn: "[data-close-modal]",
  customSelect: "[data-custom-select]",
  mobilePlaceholder: "[data-mobile-placeholder]",
  anchorLink: "[data-anchor-link]",
  anchor: "[data-anchor]",
  video: "[data-video]",
  playButton: "[data-play-video]",
  selectResize: "[data-select-resize]",
  mailChimpModal: "[data-mailchimp-modal]",
  mailChimpCloseModal: "[data-close-mailchimp-modal]",
  // Navigation
  subnav: "[data-subnav]",
  dropdownTrigger: "[data-dropdown-trigger]",
  drawerTrigger: "[data-drawer-trigger]",
  flyoutTrigger: "[data-flyout-trigger]",
  searchTrigger: "[data-search-trigger]",
  flyoutClose: "[data-flyout-close]",
  drawer: "[data-drawer]",
  flyout: "[data-flyout]",
  mobileSearchForm: "[data-mobile-search-form]",
  header: "[data-header]",
  promoBar: "[data-promo-bar]",
  // Sliders
  slickSlider: "[data-slick]",
  slickPrev: "[data-slick-prev]",
  slickNext: "[data-slick-next]",
  // video slider
  videoButtonWrapper: "[data-video-buttons]",
  // Accordions
  accordionHeading: "[data-accordion-heading]",
  accordionText: "[data-accordion-text]",
  // Tabs
  tabContainer: "[data-tab-container]",
  tab: "[data-tab]",
  tabContent: "[data-tab-content]",
  tabHeading: "[data-tab-heading]",
  tabReset: "[data-tab-reset]",
  tabResetContent: "[data-tab-reset-content]",
  // Collections
  collectionSort: "[data-collection-sort]",
  collectionGrid: "[data-collection-grid]",
  collectionFiltersContainer: "[data-collection-filters-container]",
  clearFilters: "[data-clear-filters]",
  filterCount: "[data-filter-count]",
  productId: "[data-atc-product-id]",
  // Blog
  blogGrid: "[data-blog-grid]",
  blogSort: "[data-blog-sort]",
  // PDP
  productImageZoom: "[data-image-zoom]",
  productImage: "[data-product-image]",
  productModal: "[data-product-modal]",
  productModalImage: "[data-product-modal-image]",
  productModalClose: "[data-product-modal-close]",
  optionDisplayed: "[data-option-displayed]",
  optionSelector: "[data-option-selector]",
  optionSelected: "[data-option-selector]:checked",
  atcForm: "[data-cart-submit-form]",
  atcButton: "[data-atc-button]",
  bis: "[data-bis]",
  variantSelect: "[data-variant-select]",
  imageSlider: "[data-image-slider]",
  variantPrice: "[data-variant-price]",
  variantComparePrice: "[data-variant-compare-price]",
  variantPercentOff: "[data-variant-percent-off]",
  // Cart
  inlineCart: "[data-inline-cart]",
  lineItemEntryPoint: "[data-cart-contents]",
  cartSubtotal: "[data-cart-subtotal]",
  cartCount: "[data-item-count]",
  cartShow: "[data-cart-trigger]",
  cartHide: "[data-cart-close]",
  cartPageCheckout: "[data-cart-checkout]",
  cartFull: "[data-cart-full]",
  cartEmpty: "[data-cart-empty]",
  cartIconFull: "[data-cart-icon-full]",
  cartIconEmpty: "[data-cart-icon-empty]",
  giftMessageToggle: "[data-gift-toggle]",
  giftMessage: "[data-gift-message]",
  giftMessageInput: "[data-gift-message-input]",
  giftMessageChars: "[data-gift-message-chars]",
  checkoutBtn: "[data-checkout-btn]",
  checkoutBtnPolicyAcknowledgement:
    "[data-checkout-button-policy-acknowledgement]",
  inlineCartPolicyAcknowledgement: "[data-inline-cart-policy-acknowledgement]",
  // Accounts
  password: "[data-password]",
  passwordConfirm: "[data-password-confirm]",
  passwordError: ".js-password-error",
  termsCheckbox: ".js-terms-checkbox",
  termsError: ".js-terms-error",
  createForm: "form#create_customer",
  activateForm: "form#activate_customer_password",
  address: "[data-address]",
  addressAddTrigger: "[data-add-address]",
  addressEditTrigger: "[data-edit-address]",
  addressFormCancel: ".js-address-form-cancel",
  addressAddForm: "[data-add-address-form]",
  addressEditForm: "[data-edit-address-form]",
  addressWrapper: ".js-address-wrapper",
  styledSelect: ".js-styled-select",
  orderLink: "[data-order]",
  addressInputs: ".floating-label input",
  loginForm: ".login__form",
  // International Pages
  intLanding: ".int-landing",
  intProductTile: "[data-int-product-tile]",
  intModal: "[data-int-modal]",
  intModalImg: "[data-int-modal-img]",
  intPasswordForm: "[data-int-password-form]",
  intPasswordInput: "[data-int-password-input]",
  intFormError: ".int-error",
  intLink: ".int-prod-grid__tile .grid-item__link a",
};
